const forgotPasswordSx = (theme) => ({
    root: {
        height: '100%',
        width: '100%',
        backgroundColor: '#E5E7E9',
        position: 'relative',
    },
    child: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        height: '500px',
        maxWidth: '800px',
        width: '100%',
    },
    leftCard: {
        width: '100%',
        height: '100%',
        background: 'linear-gradient(130deg, rgba(26,126,157,1) 0%, rgba(26,126,59,1) 100%)',
        zIndex: 100,
    },
    leftCardInner: {
        width: 'calc(100% - 32px)',
        marginLeft: '16px',
        marginRight: '16px',
        marginTop: '32px',
        color: '#ffffff',
        textAlign: 'center',
    },
    leftCardIcon: {
        fontSize: '7em',
        marginBottom: '32px',
        borderRadius: '50%',
        border: '4px white solid',
        padding: '16px',
    },
    leftCardWrapper: {
        zIndex: 100,
    },
    rightCard: {
        padding: '16px',
        [theme.breakpoints.down('md')]: {
            height: '100%',
            width: 'calc(100% - 32px)',
            marginLeft: '16px',
        },
        [theme.breakpoints.up('md')]: {
            width: '100%',
            marginTop: '16px',
            marginLeft: '-8px',
            paddingLeft: '72px',
            paddingRight: '64px',
            paddingTop: '32px',
            height: 'calc(100% - 32px)',
        },
        background: theme.palette.grey[100],
    },
    rightCardInner: {
        width: 'calc(100% - 32px)',
        marginLeft: '16px',
        marginRight: '16px',
        marginTop: '32px',
        color: '#ffffff',
        textAlign: 'center',
    },
    rightCardWrapper: {
        zIndex: 50,
    },
    fullHeightWidth: {
        width: '100%',
        height: '100%',
    },
    marginBottom: {
        marginBottom: '32px',
    },
    inputs: {
        marginBottom: theme.spacing(4),
    },
});

export default forgotPasswordSx;
